import { createUrlMemoryStore } from "@/hooks/useUrlMemory";

/** Cross-nav memory of the user's last active simulator tab. */
export const simulatorTabMemory = createUrlMemoryStore<string>();
